/**
 * IndicatorDescription.jsx
 * Displays indicator descriptions based on current outlook
 * Migration from front/src/components/IndicatorDescription.js
 */
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { selectOutlook } from '../store/slices/outlookSlice';
import IndicatorDescriptionParagraph from './IndicatorDescriptionParagraph';

/**
 * Component to display indicator description for current outlook
 * @param {Object} props - Component props
 * @param {Array} props.description - Array of descriptions for each outlook
 * @param {Object} props...rest - Additional props passed to IndicatorDescriptionParagraph
 * @returns {React.ReactElement} IndicatorDescription component
 */
const IndicatorDescription = ({
  description: outlookDescriptions = [],
  ...props
}) => {
  const outlookIndex = useSelector(selectOutlook).index;

  return (
    <IndicatorDescriptionParagraph
      description={outlookDescriptions[outlookIndex]}
      {...props}
    />
  );
};

IndicatorDescription.displayName = 'IndicatorDescription';

export default memo(IndicatorDescription);
